import { ReactElement, ReactNode, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import "./modalConfirm.css";

interface PropsI {
  title?: string;
  message?: ReactNode;
  actionLabel?: string;
  btnLabel?: string;
  data?: any;
  onConfirm: (id: number | null) => void;
  renderButton: (showModal: () => void) => ReactNode;
}

export const ModalConfirm = ({
  onConfirm,
  renderButton,
  title = "Atención",
  message,
  actionLabel = "Confirmar",
  btnLabel = "Confirmar",
  data,
}: PropsI) => {
  const [show, setShow] = useState(false);
  const [horaId, setHoraId] = useState(null);

  const handleClickConfirmar = () => {
    handleClose();
    onConfirm(horaId);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {renderButton ? (
        renderButton(handleShow)
      ) : (
        <Button variant="light" onClick={handleShow}>
          {btnLabel}
        </Button>
      )}

      <Modal
        className="modal-confirm"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <div className="modal-confirm-message">
                {message ?? <p>¿Deseas confirmar la accion?</p>}
              </div>

              {data?.length && (
                <Col md="8" className="mb-3 w-100">
                  <div>Seleccione un horario</div>
                  <select
                    name="horas"
                    id="horas"
                    onChange={(e: any) => {
                      setHoraId(e.target.value);
                    }}
                    className="custom-form-input form-control-lg w-100"
                  >
                    <option value="" disabled selected>
                      Seleccionar una opción
                    </option>
                    {data?.map((hora: any) => (
                      <option key={hora.id} value={hora.id}>
                        {hora.orden} - {hora.seccion.nombre} - {hora.dia.nombre}
                      </option>
                    ))}
                  </select>
                </Col>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex gap-2">
          <Button variant="light" size={"lg"} onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            size={"lg"}
            onClick={handleClickConfirmar}
            disabled={data?.length && !horaId ? true : false}
          >
            {actionLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
